import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { CircularProgress, IconButton, Stack, Typography, useTheme } from '@mui/material';

import { predefinedPromptsByRoleTexts } from '../../../constants';
import { useDeletePredefinedPromptByRole } from '../../../services/queries';

interface PromptSectionTitleProps {
    promptIndex: number;
    roleId: string;
    promptId?: string;
    deleteDynamicField: (promptIndex: number) => void;
}

export const PromptSectionTitle = ({
    promptIndex,
    roleId,
    promptId,
    deleteDynamicField,
}: PromptSectionTitleProps) => {
    const theme = useTheme();
    const { mutate: deletePredefinedPromptByRole, isPending: isDeleting } =
        useDeletePredefinedPromptByRole();

    const promptNumber = promptIndex + 1;
    const promptLabel = predefinedPromptsByRoleTexts.promptLabel + promptNumber;

    const handleClick = promptId
        ? () => deletePredefinedPromptByRole({ roleId, promptId })
        : () => deleteDynamicField(promptIndex);

    return (
        <Stack direction='row' alignItems='center' gap={1}>
            <Typography variant='subtitle2'>{promptLabel}</Typography>
            <IconButton onClick={handleClick} disabled={isDeleting}>
                <DeleteRoundedIcon sx={{ color: theme.palette.customColors.orange }} />
            </IconButton>
            {isDeleting && (
                <CircularProgress size={24} sx={{ color: theme.palette.customColors.purple }} />
            )}
        </Stack>
    );
};
